import React, { useState, useEffect, useRef } from "react";
import {
  Typography,
  Breadcrumbs,
} from "@mui/material";
import { IoMenu } from "react-icons/io5";
import { Link, useLocation } from "react-router-dom";
import { IoIosArrowDown as Arrow } from "react-icons/io";
import logo from "../assets/WhatsApp Image 2024-12-03 at 3.41.47 PM.jpeg"
import "./navbar.css";

const navItems = [
  { title: "HOME", url: "/" },
  { title: "MANAGEBAC", url: "https://tispk.managebac.com/login" },
  { title: "APPLYNOW", url: "/login" },
  {
    title: "Service",
    link: "#",
    subMenu: [
      {
        title: "About us",
        subMenu: [
          { title: "TIS History", url: "/Tishistory" },
          { title: "Strategic Plan", url: "/StrategicPlan" },
          { title: "Head’s Message", url: "/HeadsMessage" },
          { title: "Board of Governors", url: "/BoardOfGoverners" },
          { title: "Parent Council", url: "/ParentCouncil" },
          { title: "School Leadership Team", url: "/SchoolLeadershipTeam" },
          { title: "Accreditation", url: "/Accreditation" },
          { title: "Organisational Charts", url: "/OrganizationalCharts" },
          { title: "Our Vision", url: "/OurVision" },
          { title: "Gallery", url: "/Gallery" },
          { title: "Testimonials", url: "/Testimonials" },
        ],
      },
      {
        title: "Academics",
        subMenu: [
          {
            title: "Primary School",
            subMenu: [
               { title: "Pre School", url: "/preschool" },
              { title: "Curriculum", url: "/Curriculum" },
              { title: "Assessment", url: "/Assessment" },
              {
                title: "Extra Curriculum Programmes",
                url: "/ExtraCircullarProgram",
              },
            ],
          },
          {
            title: "Middle School",
            subMenu: [
              { title: "Global Contexts", url: "/GlobalContexts" },
              { title: "Conceputal Learning", url: "/ConceptualLearning" },

              {
                title: "Approaches of Learning (ATL)",
                url: "/ApproachesToLearn",
              },
              { title: "MYP Projects", url: "/MYPProjects" },
            { title: "National Requirments", url: "/NationalRequirements" },
              { title: "MYP Assessments", url: "/MYPAssessments" },
            ],
          },
          {
            title: "High School",
            subMenu: [
              { title: "IB Diploma Programme", url: "/IBDiploma" },
              { title: "Core Programme", url: "/CoreProgram" },
              {
                title: "Group 1: studies in Langauage and Lierature",
                url: "/StudiesInLanguage",
              },
              {
                title: "Group 2: Langauage Acquisition",
                url: "/LanguageAcquisition",
              },
              {
                title: "Group 3: Individuals and Societies",
                url: "/IndividualsAndSocieties",
              },
              { title: "Group 4: Sciences", url: "/Sciences" },
              { title: "Group 5: Mathematics", url: "/Mathematics" },
              { title: "Group 6: Arts", url: "/TheArts" },
              { title: "Assessments", url: "/Assessment" },
              { title: "Award of IB Diploma", url: "/AwardOfDiploma" },
              { title: "Library", url: "/Library" },
            ],
          },
          {
            title: "Continuum",
            subMenu: [
              { title: "Culminating Events", url: "/CulminatingEvents" },
              { title: "Action", url: "/Action" },
              {
                title: "International Mindedness",
                url: "/InternationMindedness",
              },
            ],
          },
        ],
      },
      {
        title: "Admission",
        subMenu: [
          { title: "Enroll Now", url: "/Login" },
          { title: "Meet the Admission Team", url: "/MeetTheAdmissionTeam" },
          { title: "Admission Requirment", url: "/AdmissionRequirements" },
          { title: "Admission Process", url: "/AdmissionProcess" },
          { title: "Scohlarship Criteria", url: "/Scholarship" },
          { title: "FEE Structure", url: "/FeeStructure" },
          
        ],
      },
      {
        title: "Life at TIS",
        subMenu: [
          { title: "Africa Europe & Asia", url: "/AfricaEuropeAsia" },
          {
            title: "Student Personal Development",
            url: "/StudentPersonalDevelopment",
          },
          { title: "Code Of Conduct", url: "/CodeOfConduct" },
          { title: "CAS Programme", url: "/CASProgram" },
          { title: "Societies and Club", url: "/SocietiesAndClub" },
          { title: "Cafeteria", url: "/Cafeteria" },
          { title: "Conselling (Personal, Academic)", url: "/Counselling" },
          {
            title: "Career & University Conselling",
            url: "/CareerAndUniCounseling",
          },
          { title: "TIS Language Profile", url: "/TISLanguageProfile" },
          {
            title: "TIS Parliment, Study Assembly & Goverment",
            url: "/TISParliament",
          },
        ],
      },
      {
        title: "Alumni",
        subMenu: [
          { title: "Alumni", url: "/Alumni" },
          { title: "Alumni Login", url: "/alumni/login" },
          { title: "Alumni Registration", url: "/alumni/signup" },
        ],
      },
{
        title: "Contact US",
        subMenu: [
          {
            title: "Contact Details",
            url: "/ContactDetails",
          },
        ],
      },
    ],
  },
];

function Navbar() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Close the menu when the location (URL) changes

    if (isFirstRender.current) {
      isFirstRender.current = false; // Skip the first render
      return;
    }
    console.log("location.pathname",location.pathname)
    setIsMenuOpen(false);
    toggleMenu()
  }, [location.pathname]);
  // console.log("location.pathname",location.pathname)

  const toggleMenu = () => {

    setIsMenuOpen((prev) => !prev);
    console.log("isMenuOpen",isMenuOpen)
  };

  const renderMenu = (items) => {
    return (
      <ul>
        {items?.map((item, index) => (
          <li key={index}>
            {item.title === "Service" ? (
              <IoMenu className="text-myYellow" size={"35"} onClick={toggleMenu}/>
            ) : item.title === "HOME" ? (
              <Link
                to={"/"}
                className="text-black text-[14px] font-bold border-solid pr-2 border-white border-r-[1px] hidden md:block"
                style={{ color: "rgb(38 61 95 / var(--tw-text-opacity, 1))", backgroundColor: 'white' }}
              >
                HOME
              </Link>
            ) : item.title === "MANAGEBAC" ? (
              <Link
                to={"https://tispk.managebac.com/login"}
                className="text-black text-[14px] font-bold border-solid pr-2 border-white border-r-[1px] hidden md:block"
                style={{ color: "rgb(38 61 95 / var(--tw-text-opacity, 1))", backgroundColor: 'white' }}
              >
                MANAGEBAC
              </Link>
            ) : item.title === "APPLYNOW" ? (
              <Link
                to={"/login"}
                className="text-black text-[14px] font-bold border-solid pr-2 border-white border-r-[1px] hidden md:block"
                style={{ color: "rgb(38 61 95 / var(--tw-text-opacity, 1))", backgroundColor: 'white' }}
              >
                APPLY NOW
              </Link>
            ) : (
              <Link className="flex items-center gap-[10px]" to={item.url}
              >
                {item.title}
                {item.subMenu && <Arrow className="ml-1 text-white" />}
              </Link>
            )}
            {item.subMenu && renderMenu(item.subMenu)}
          </li>
        ))}
      </ul>
    );
  };
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [activeLink, setActiveLink] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState("");
  const [section, setSection] = useState("");
  
console.log("navbaraaa")


  const pathnames = location.pathname.split("/").filter((x) => x);
  return (
    <div className="h-[90px] fixed inset-x-0 top-0 z-[999] flex flex-col px-5 bg-white py-2 border-4 border-white">
     
     <div className="flex flex-row justify-between items-center">
        <div>
          <h6
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              color: "rgb(247, 198, 18)",
              marginRight: "10px",
            }}
          >
            <img
              src={logo}
              alt="Logo"
              style={{ height: "70px", objectFit: "contain" }}
            />
          </h6>
   
        </div>
        <Breadcrumbs aria-label="breadcrumb" style={{ color: "rgb(38 61 95 / var(--tw-text-opacity, 1))" ,fontWeight: "bold" }}>
            <Link to="/" style={{ color: "rgb(38 61 95 / var(--tw-text-opacity, 1))", textDecoration: "none" }}>
              Home
            </Link>
            {pathnames.map((value, index) => {
              const to = `/${pathnames.slice(0, index + 1).join("/")}`;
              return index === pathnames.length - 1 ? (
                <Typography key={to} color="rgb(38 61 95 / var(--tw-text-opacity, 1))" style={{ fontWeight: "bold" }} >
                  {value.replace(/-/g, " ")}
                </Typography>
              ) : (
                <Link
                  key={to}
                  to={to}
                  style={{ color: "rgb(38 61 95 / var(--tw-text-opacity, 1))", textDecoration: "none" ,fontWeight: "bold"}}
                >
                  {value.replace(/-/g, " ")}
                </Link>
              );
            })}
          </Breadcrumbs>
        <nav className={`navbar gap-2 ${isMenuOpen ? "open" : ""}`}>{renderMenu(navItems)}</nav>
      </div>

      <div className="mt-[10px]">
       
      </div>
    </div>
  );
}


export default Navbar;


